import React from 'react';
import store from '../../../../Store'
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {
    setDefaultDisplayNameForm, setSiteId,setOrganizationId,setSiteName
} from "./DisplayNameForm-Action";
import createSiteDisplayName from "../../../../ajax/actions/sites/site_displayname_post";


class displayNameFormWorker extends React.Component {

    constructor(props) {
        super(props);
        store.dispatch(setDefaultDisplayNameForm())
        store.dispatch(setSiteId(this.props.match.params.id))
        store.dispatch(setOrganizationId(this.props.match.params.org_id))
        store.dispatch(setSiteName(this.props.data))
    }

    componentDidUpdate(prev) {
        let {dispatchAPI} = this.props;
        if (dispatchAPI) {
            if (!prev.dispatchAPI) {
                store.dispatch(createSiteDisplayName(this.props.match.params.id))
            }
        }
    }

    render() {
        return null
    }
}

function mapStateToProps(state) {
    let {displayNameForm, createSiteDisplayName,} = state;
    let {dispatchAPI, mode, payload} = displayNameForm.data;
    return {displayNameForm, dispatchAPI, mode, payload, createSiteDisplayName};
}

export default withRouter(connect(mapStateToProps)(displayNameFormWorker));